import { SharedFeatureEventsApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useSharedFeatureEventsApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new SharedFeatureEventsApi(configuration),
    [configuration]
  );
};
